import React from 'react';
import ArticleField from '../ArticleField';
import { TextField } from '@material-ui/core';

interface ShortHatProps {
    value: string,
    onChange: (value: string) => void
}

const ShortHat = (props: ShortHatProps) => (
    <ArticleField label="Chapeau court *">
        <TextField
            variant="outlined"
            multiline rows={4}
            fullWidth={true}
            required
            value={props.value}
            onChange={(e) => {
                props.onChange(e.target.value);
            }} />
    </ArticleField>
);

export default ShortHat;